/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustEnumOption
 */
export interface AdminStockAdjustEnumOption {
    /**
     * 枚举值
     * @type {number}
     * @memberof AdminStockAdjustEnumOption
     */
    value?: number;
    /**
     * 显示名称（国际化）
     * @type {string}
     * @memberof AdminStockAdjustEnumOption
     */
    label?: string;
}

/**
 * Check if a given object implements the AdminStockAdjustEnumOption interface.
 */
export function instanceOfAdminStockAdjustEnumOption(value: object): value is AdminStockAdjustEnumOption {
    return true;
}

export function AdminStockAdjustEnumOptionFromJSON(json: any): AdminStockAdjustEnumOption {
    return AdminStockAdjustEnumOptionFromJSONTyped(json, false);
}

export function AdminStockAdjustEnumOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustEnumOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function AdminStockAdjustEnumOptionToJSON(json: any): AdminStockAdjustEnumOption {
    return AdminStockAdjustEnumOptionToJSONTyped(json, false);
}

export function AdminStockAdjustEnumOptionToJSONTyped(value?: AdminStockAdjustEnumOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

